﻿import $ from "jquery"
import GetUrlParameter from '../utils/getUrlParameter'

let returnUrl = GetUrlParameter("returnurl");
$("#form-uvm-login")
    .on("submit",
        function(e) {
            e.preventDefault();

            var data = $("#form-uvm-login").serialize() + "&returnurl=" + returnUrl;
            $.ajax({
                    method: "POST",
                    url: "/api/SiteAuthentication/login",
                    data: data,
                    contentType: 'application/x-www-form-urlencoded',
                    dataType: 'json'
                })
                .done(function(data) {
                    document.location = data;
                })
                .fail(function() {
                    alert("error");
                });
        });


//////////////////
// WEBPACK FOOTER
// ./Scripts/login/login.js
// module id = 22
// module chunks = 3